import React, { useEffect, useRef, useState } from "react";
// import logolight from "../../assets/images/only-switch-logo.png";
// import logodark from "../../assets/images/only-switch-logo.png";
import logolight from "../../assets/images/sixbit-logo-bg.jpg";
import logodark from "../../assets/images/sixbit-logo-bg.jpg";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  InputGroup,
  Button,
  FormGroup
} from "reactstrap";
import { connect } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import {
  clearFormLogin,
  clearLoginUserError,
  formLogin,
  setIsLoading,
  userLogin
} from "../../store/actions";
import Message from "../../CommonData/Data/Message";

const Login = props => {
  const { isAuth, errorMessage, form } = props;
  const { errors, formAddLogin } = form || {};
  const [showPasword, setshowPasword] = useState(true);
  const credits = window.__ENV && window.__ENV.credits;

  useEffect(() => {
    props.clearLoginUserError();
    props.formLogin({
      formAddLogin: {},
      errors: {}
    });
    props.setIsLoading(true);
    return () => {
      props.clearFormLogin();
    }
  }, [])

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    props.formLogin({
      ...form,
      formAddLogin: {
        ...form.formAddLogin,
        [name]: value,
      },
      errors: {
        ...form.errors,
        [name]: null,
      }
    });
  }

  //focus down while press enter 
  const emailInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      passwordInputRef.current.focus();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const { username, password } = formAddLogin || {};
    let currentErrors = {};
    if (!username) {
      currentErrors.username = 'Email is required'
    }
    if (!password) {
      currentErrors.password = 'Password is required'
    }
    props.formLogin({
      ...form,
      errors: currentErrors
    });
    if (Object.keys(currentErrors).length === 0) {
      props.setIsLoading(false);
      props.userLogin();
    }
  };
  return isAuth ? (<Navigate to='/dashboard' />) : (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="text-center">
                      <Link to="/">
                        <img
                          src={logodark}
                          alt=""
                          height="80"
                          className="auth-logo logo-dark mx-auto"
                        />
                        <img
                          src={logolight}
                          alt=""
                          height="80"
                          className="auth-logo logo-light mx-auto"
                        />
                      </Link>
                    </div>
                    {/* <h4 className="font-size-18 text-muted mt-2 text-center">
                      SIXBIT PORTAL
                    </h4> */}
                    <Row className='mt-5'>
                      {errorMessage && (
                        <Message
                          type="danger"
                          defaultMessage={errorMessage}
                          baseClassName="alert"
                        />
                      )}
                      <Form className="form-horizontal" name="formAddLogin">
                        <Col md={12}>
                          <FormGroup className="mb-4">
                            <Label className="form-label">Email</Label><span className="text-danger">*</span>
                            <InputGroup>
                              <Input
                                autoFocus
                                innerRef={emailInputRef}
                                className={errors && errors.username ? "form-control border-end-0" : " border-end-0 form-control border-secondary"}
                                placeholder="Enter email"
                                type="email"
                                name="username"
                                onChange={handleOnChange}
                                onKeyPress={handleKeyDown}
                                value={(formAddLogin && formAddLogin.username) || ""}
                                invalid={errors && errors.username}
                              />
                              <Button
                                color='white'
                                className={errors && errors.username ? "border-danger border border-1 border-start-0 rounded-end" : 'border-dark border-start-0 rounded-end'}
                                disabled
                              ><i class="fas fa-envelope text-dark"></i>
                              </Button>
                              <FormFeedback>{errors && errors.username}</FormFeedback>
                            </InputGroup>
                          </FormGroup>
                          <FormGroup className="mb-4">
                            <Label className="form-label">Password</Label><span className="text-danger">*</span>
                            <InputGroup>
                              <Input
                                innerRef={passwordInputRef}
                                className={errors && errors.password ? "border-end-0" : 'border-end-0 border-secondary'}
                                name="password"
                                type={showPasword ? "password" : "text"}
                                placeholder="Enter password"
                                onChange={handleOnChange}
                                onKeyPress={handleKeyPress}
                                value={(formAddLogin && formAddLogin.password) || ''}
                                invalid={errors && errors.password}
                              />
                              <Button
                                className={errors && errors.password ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
                                color='white'
                                onClick={() => setshowPasword(!showPasword)}
                              >
                                {showPasword ?
                                  <i className="fas fa-eye text-secondary"></i>
                                  :
                                  <i class="fas fa-eye-slash text-secondary"></i>
                                }
                              </Button>
                              {errors && errors.password && (
                                <FormFeedback>{errors && errors.password}</FormFeedback>
                              )}
                            </InputGroup>
                          </FormGroup>
                          <Row>
                            <Col>
                              <div className="text-md-end mt-3 mt-md-0">
                                <Link
                                  to="/auth-recoverpw"
                                  className="text-muted"
                                >
                                  <i className="mdi mdi-lock"></i> Forgot Password?
                                </Link>
                              </div>
                            </Col>
                          </Row>
                          <FormGroup className="d-grid mt-4">
                            <Button
                              className="waves-effect waves-light"
                              color='primary'
                              type="submit"
                              onClick={handleSubmit}
                              disabled={!props.isloading}
                            >
                              {!props.isloading ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Loading...
                                </>
                              ) : (
                                "Log In"
                              )}
                            </Button>
                          </FormGroup>
                        </Col>
                      </Form>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <div className="position-absolute bottom-0 start-50 translate-middle-x mt-5 text-center">
          <p className="text-white-50">
            © {new Date().getFullYear()} {credits}.
          </p>
        </div>

      </div>
    </React.Fragment >
  );
};

const mapStateToProps = (state) => ({
  form: state.login.form,
  currentProfile: state.login.currentProfile,
  isAuth: state.login.isAuth,
  errorMessage: state.login.errorMessage,
  isloading: state.login.isloading
});

const mapDispatchToProps = (dispatch) => ({
  formLogin: (form) => dispatch(formLogin(form)),
  clearFormLogin: () => dispatch(clearFormLogin()),
  userLogin: () => dispatch(userLogin()),
  setIsLoading: (isloading) => dispatch(setIsLoading(isloading)),
  clearLoginUserError: () => dispatch(clearLoginUserError())
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);